import { useState } from "react";
import { auth } from "../../firebase";
import { sendPasswordResetEmail } from "firebase/auth";
import { Mail, Loader2 } from "lucide-react";
import { BackButton } from "@/components/ui/BackButton";

export default function ResetPasswordForm({ onSwitchToLogin }) {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleReset = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);
    try {
      await sendPasswordResetEmail(auth, email);
      setMessage("RECOVERY SIGNAL SENT. CHECK INBOX.");
    } catch (err) {
      setError(err.message.replace("Firebase: ", "").toUpperCase());
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-6 animate-in fade-in zoom-in-95 duration-300">
      <div className="text-center group">
        <h2 className="text-3xl font-black mb-1 text-white tracking-tighter uppercase italic bg-gradient-to-r from-indigo-400 via-purple-400 to-emerald-400 bg-clip-text text-transparent">
           Recover Access
        </h2>
        <p className="text-[9px] text-zinc-500 uppercase tracking-[0.3em] font-black font-mono">Reset.Credentials()</p>
      </div>

      {error && <div className="p-3 bg-red-500/5 border-l-2 border-red-500 text-red-500 text-[10px] font-mono font-bold uppercase">{error}</div>}
      {message && <div className="p-3 bg-emerald-500/5 border-l-2 border-emerald-500 text-emerald-500 text-[10px] font-mono font-bold uppercase">{message}</div>}

      <form onSubmit={handleReset} className="flex flex-col gap-4">
        <div className="space-y-1.5">
            <label htmlFor="reset-email" className="text-[9px] font-mono text-zinc-600 uppercase ml-1 flex items-center gap-2">
                <Mail size={10} /> Email_Address
            </label>
            <input
                id="reset-email"
                type="email"
                placeholder="OPERATIVE@TYPEBATTLE.IO"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full p-4 bg-zinc-950 border border-zinc-800 rounded-sm text-white text-xs font-mono focus:border-indigo-500 outline-none transition-all placeholder:text-zinc-800"
            />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-indigo-600 hover:bg-indigo-500 text-white font-black text-[11px] uppercase tracking-[0.2em] py-5 rounded-sm transition-all flex items-center justify-center disabled:opacity-50 mt-6 font-mono italic"
        >
          {loading ? <Loader2 size={18} className="animate-spin" /> : "SEND_RESET_LINK"}
        </button>
      </form>

      <div className="text-center pt-2">
        <BackButton onClick={onSwitchToLogin} className="w-full justify-center">
          Return to Login
        </BackButton>
      </div>
    </div>
  );
}